<template>
	<div class="question-container">
		<span class="question-number"
			:style="`background-color:${$appColors.primary};color:${$appColors.white}`"
		>{{order}}</span>
		<p class="question-text"
			:style="`color:${$appColors.secondary}`"
		>{{question.question.name}}</p>
		<component
			:is="currentTemplate"
			:question-id="question.id"
			:answers="question.answer.details"
			@selected-icon="selectedAnswer"
		></component>
	</div>
</template>
<script>
function selectedAnswer(id) {
	this.$emit('selected-icon', id, this.question.questionId);
}

function currentTemplate() {
	const { id } = this.question.answer ? this.question.answer.typeAnswer : null;
	const opt = {
		1: 'facesTemplate',
		2: 'radioButtonTemplate',
		3: 'checkButtonTemplate',
		4: 'facesTextTemplate',
	};
	return opt[id];
}
export default {
	name: 'questions-component',
	components: {
		radioButtonTemplate: () => import('polls/radio-button-template'),
		checkButtonTemplate: () => import('polls/check-button-template'),
		facesTextTemplate: () => import('polls/faces-text-template'),
		facesTemplate: () => import('polls/faces-template'),
	},
	computed: {
		currentTemplate,
	},
	methods: {
		selectedAnswer,
	},
	props: {
		order: Number,
		question: {
			default: () => {},
			type: Object,
		},
	},
};
</script>
<style lang="scss" scoped>
	.question-container {
		display: grid;
		grid-column-gap: 10px;
		grid-row-gap: 15px;
		grid-template-columns: 0.5fr 4fr;
		grid-template-rows: repeat(auto-fit, minmax(40px, 1fr));
		padding-top: 45px;

		@media (max-width: 768px) {
			grid-template-columns: 1fr;
			grid-template-rows: auto;
			padding-top: 35px;
		}
	}

	.question-number {
		align-items: center;
		border-radius: 50%;
		display: flex;
		font-family: font(bold);
		font-size: size(sbig);
		grid-column: 1;
		grid-row: 1 / span 2;
		height: 28px;
		justify-content: center;
		margin: 0 0 0 auto;
		width: 28px;

		@media (max-width: 768px) {
			grid-row: 1;
			margin: 0 auto;
		}
	}

	.question-text {
		font-family: font(bold);
		margin: 0 auto;
		max-width: 100%;
		padding: 0 20px;
		text-align: center;

		@media (max-width: 500px) {
			font-size: size(large);
			line-height: normal;
			font-family: "Times New Roman", Times, serif;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/polls/question-component.vue